export default __webpack_public_path__ + "static/media/1734.3fe4ab2c.png";